import type {
  SchedulingPlan,
  SchedulingPlanLine,
} from 'syft-acp-core/store/agency-cascade-scheduling-plans/types'

export const authoredReasonLabels: Record<SchedulingPlan['authored_reason'], string> = {
  accepted: 'Agency Accepted',
  shift_added: 'Shift added',
  shift_rescheduled: 'Shift rescheduled',
  reallocated: 'Reallocated',
}

export const lineStateLabels: Record<SchedulingPlanLine['state'], string> = {
  scheduled: 'Scheduled',
  evaluated: 'Deadline passed',
  met: 'Met',
  not_enforceable: 'Not enforceable',
}

/**
 * Readable form of a wire value that has no label yet, e.g. `skipped_past` → "Skipped past". flex-core
 * can add values ahead of ACP, so lookups fall back to this instead of rendering nothing.
 */
export const humanizeWireValue = (value: string) => {
  const words = value.replace(/_/g, ' ').trim()

  return words.charAt(0).toUpperCase() + words.slice(1)
}

const labelOrHumanized = (labels: Record<string, string>, value: string) =>
  labels[value] ?? humanizeWireValue(value)

export const getAuthoredReasonLabel = (reason: string) => labelOrHumanized(authoredReasonLabels, reason)

export const getLineStateLabel = (state: string) => labelOrHumanized(lineStateLabels, state)
